import { render, staticRenderFns } from "./DomainInsights.vue?vue&type=template&id=c933f8be&scoped=true"
import script from "./DomainInsights.vue?vue&type=script&lang=js"
export * from "./DomainInsights.vue?vue&type=script&lang=js"
import style0 from "./DomainInsights.vue?vue&type=style&index=0&id=c933f8be&prod&lang=scss&scoped=true"
import style1 from "./DomainInsights.vue?vue&type=style&index=1&id=c933f8be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c933f8be",
  null
  
)

export default component.exports